'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useIsSafariVersion18 } from '../../hooks/use-is-safari-version-18.js';
import { TransitionStatus } from '../../hooks/use-transition.js';
import { useInternalDialogConfigContext as g } from './dialog.component.js';
import { useModalDialogContext } from './modal-dialog.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, o) {
    return t in e ? Object.defineProperty(e, t, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = o, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var o = null != arguments[t] ? arguments[t] : {}, r = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), r.forEach(function(t) {
            _define_property(e, t, o[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var o = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        o.push.apply(o, r);
    }
    return o;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(o) {
        Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var o, r, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(r = 0; r < a.length; r++)o = a[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var o, r, n = {}, a = Object.keys(e);
    for(r = 0; r < a.length; r++)o = a[r], t.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const ModalDialogContent = renderWithRef('ModalDialogContent', null, (n, d)=>{
    let { bgc: s, backgroundColor: c, variant: m, takeOver: u, footerPinned: b, bodyWidth: f, transitionState: g$1, isModal: w } = useModalDialogContext(), { portalRef: y } = g(), { fullBleed: O = false, children: j, style: _ } = n, h = _object_without_properties(n, [
        "fullBleed",
        "children",
        "style"
    ]), v = new Set([
        'swan-modal-dialog'
    ]);
    w || v.add('swan-modeless-dialog'), O && v.add('swan-modal-dialog-skin-full-bleed'), TransitionStatus.ENTERED === g$1 && v.add('swan-modal-dialog-visible'), m && [
        'panel-right',
        'panel-left',
        'panel-bottom',
        'panel-top',
        'menu'
    ].includes(m) && v.add('swan-modal-dialog-panel'), m && [
        'panel-left',
        'menu'
    ].includes(m) && v.add('swan-modal-dialog-panel-left'), m && [
        'panel-right',
        'panel-left',
        'panel-bottom',
        'panel-top',
        'menu'
    ].includes(m) && 'capped' === f && v.add('swan-modal-dialog-panel-capped'), 'grow' === f && v.add('swan-modal-dialog-grow'), 'panel-bottom' === m && v.add('swan-modal-dialog-panel-bottom'), 'panel-top' === m && v.add('swan-modal-dialog-panel-top'), 'menu' === m && v.add('swan-modal-dialog-panel-menu'), u && v.add('swan-modal-dialog-takeover'), b && v.add('swan-modal-dialog-panel-pinned');
    let P = useIsSafariVersion18(), k = _object_spread({}, _);
    return P && (k.minHeight = '-webkit-fill-available', k.maxHeight = '-webkit-fill-available'), jsxs(Fragment, {
        children: [
            jsx(RenderComp, {
                root: "div",
                forwardedRef: d,
                classNames: v,
                props: _object_spread_props(_object_spread({
                    bgc: s,
                    backgroundColor: c
                }, h), {
                    style: k
                }),
                children: j
            }),
            jsx("div", {
                ref: y
            })
        ]
    });
});

export { ModalDialogContent };
